export const ROCKY_CHAT_MESSAGES_LIMIT = 100;
export const ROCKY_CHAT_MESSAGES_OFFSET = 0;
